import { FC } from 'react';
import { Form } from 'react-bootstrap';
// import './InputField.css';

interface InputFieldProps {
  placeholder?: string;
  label?: string;
  type: string;
  onChange?: (value: string) => void;
  value?: string;
  id: string;
}

const InputField: FC<InputFieldProps> = ({
  placeholder,
  label,
  type,
  onChange,
  value,
  id,
}) => {
  return (
    <div className="custom-border width">
      <Form.Group>
        {label && <Form.Label>{label}</Form.Label>}
        <Form.Control
          className="border"
          type={type}
          placeholder={placeholder}
          onChange={(e) => onChange && onChange(e.target.value)}
          value={value}
          id={id}
        />
      </Form.Group>
    </div>
  );
};

export default InputField;
